import React from 'react';

class AccessDeniedPage extends React.Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }
  handleTouchTap() {
    location.reload();
  }
  render() {
    return (
      <div className="loginwrapper">
        <div className="accessdeniedpanel">
                <h4>Er is geen geldige licentie gevonden</h4>
                <button className="accessdeniedbtn" onClick={this.handleTouchTap}> Probeer het nog een keer </button>
        </div>
      </div>
    )
  }
}

export default AccessDeniedPage



// WEBPACK FOOTER //
// src/pages/AccessDeniedPage.jsx